import { r as registerInstance, c as createEvent, h, d as getElement } from './index-0859a102.js';
import { isEmpty } from 'lodash';
import { T as ThemeManager } from './theme-manager-3e7fd8c2.js';
import { R as RoutingHelpers } from './routing-helpers-c737a977.js';
import { g as getAssetRelativePath } from './relativepath-helper-948108b1.js';
import 'lodash/trim';
import 'rxjs';

const cosoMenuCss = "button.btn.btn-primary.theme-button:focus-visible{outline:none !important;box-shadow:none !important;background-color:var(--focus-background-color) !important;color:var(--focus-color) !important}button.btn.btn-primary.theme-button{color:var(--navbar-dark-color)}.data-center-identifier{color:var(--white);border-left:var(--white) 1px solid;font-weight:600;margin-right:2em}";
const CosoMenuStyle0 = cosoMenuCss;

const CosoMenu = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.menuSignInClicked = createEvent(this, "menuSignInClicked", 7);
        this.menuSignOutClicked = createEvent(this, "menuSignOutClicked", 7);
        this.isAuthenticated = false;
        this.identityProviderEndpoint = "";
        this.shellEndpoint = "";
        this.dashboardEndpoint = "";
        this.logoHref = "";
        this.logoAriaLabel = "";
        this.tenantName = null;
        this.userName = null;
        this.isMvc = false;
        this.isIdentityProvider = false;
        this.supportsMultiTheme = true;
        this.supportsApplicationDrawer = true;
        this.supportsAccountCreation = true;
        this.supportsAuthentication = true;
        this.supportsTenantRename = false;
        this.wrapMenuWithContainerWhenApplicationDrawerIsNotSupported = true;
        this.angularRouter = undefined;
        this.angularNgZone = undefined;
        this.hasStickyNavbar = true;
        this.loginRedirectUrl = "/Authentication/Login";
        this.logoutRedirectUrl = "/Authentication/Logout";
        this.baseAssetPath = undefined;
        this.dataCenterEU = false;
        this.dataCenterUS = false;
        this.currentTheme = undefined;
    }
    connectedCallback() {
        this.themeManagerSubscription = ThemeManager.instance.theme$.subscribe((theme) => (this.currentTheme = theme));
    }
    disconnectedCallback() {
        this.themeManagerSubscription.unsubscribe();
    }
    toggleTheme() {
        ThemeManager.instance.toggleTheme();
    }
    onLogoClicked(e) {
        RoutingHelpers.navigate(this.getLogoHref(), e, this.angularRouter, this.angularNgZone);
    }
    getLogoHref() {
        return isEmpty(this.logoHref) ? (isEmpty(this.dashboardEndpoint) ? "/" : this.dashboardEndpoint) : this.logoHref;
    }
    getLogoAriaLabel() {
        return isEmpty(this.logoAriaLabel) ? "Home" : this.logoAriaLabel;
    }
    removeHiddenAttribute() {
        this.navElement = this.el.querySelector(".visible-nav");
        this.observer = new MutationObserver((mutations) => {
            for (let mutation of mutations) {
                if (mutation.type === "attributes" && mutation.attributeName === "hidden") {
                    const isHidden = this.navElement.hasAttribute("hidden");
                    if (isHidden) {
                        this.navElement.removeAttribute("hidden");
                    }
                }
            }
        });
        this.observer.observe(this.navElement, {
            attributes: true,
            childList: false,
            subtree: false,
        });
    }
    componentDidLoad() {
        this.removeHiddenAttribute();
    }
    componentWillUnload() {
        this.observer.disconnect();
    }
    render() {
        const menuContent = [
            h("div", { key: 'b3a5f1ccc11abdf7b9846d1a4bbce7dab27d69a4', class: "d-flex" }, h("div", { key: '424e869fe2e58d054d345bed8ebfe02d215f4e1b', class: "navbar-brand" }, h("a", { key: '19c97845595dda2490b7c010538a1764430cf6d3', href: this.getLogoHref(), class: "d-inline-block", onClick: (e) => this.onLogoClicked(e), "aria-label": this.getLogoAriaLabel() }, h("slot", { key: 'f383e101a26e43de0b21c40933adeb272dcca90f', name: "logo" }, h("img", { key: 'ee961e89d20c2d2c9fdde2082f950d40f58d9bbd', src: getAssetRelativePath("./assets/images/connecting-software-white-logo.svg", this.baseAssetPath), class: "logo-scale", alt: "Connecting Software Logo" })))), this.dataCenterEU && !this.dataCenterUS ? (h("div", { class: "d-flex align-items-center" }, h("span", { class: "data-center-identifier pl-1" }, "EU"))) : undefined, this.dataCenterUS && !this.dataCenterEU ? (h("div", { class: "d-flex align-items-center" }, h("span", { class: "data-center-identifier pl-1" }, "US"))) : undefined),
            h("button", { key: 'b80a674af8799400910b25fb9cd9b50a0dbb6ba2', class: "navbar-toggler", type: "button", "data-toggle": "collapse", "data-target": "#navbarColor01", "aria-controls": "navbarColor01", "aria-expanded": "false", "aria-label": "Toggle navigation" }, h("span", { key: '217c80f0453c08df325695ed948ff54f5464f069', class: "fa fa-bars", "aria-hidden": "true" })),
            h("div", { key: '86bb3c8442a216a60fcfe4e3196331899c51d76c', class: "collapse navbar-collapse", id: "navbarColor01" }, h("div", { key: 'a5c767d633b42a50e04d8a7733a0ae9e18c5e99e', class: "mr-auto" }, h("slot", { key: '5f17df4df4d225ddd500ce36f0b68a7d64290535', name: "mainMenu" })), h("slot", { key: '638444f4316fab37ceef6234f8785f3e63a903be', name: "mainMenuRightNavbar" }, h("slot", { key: 'e72289cbb454b9e4da377341ee3b74b74fa0e4fc', name: "extraNavigation" }), this.supportsMultiTheme ? (h("button", { class: "btn btn-primary theme-button", onClick: () => this.toggleTheme(), "aria-label": `Toggle to ${this.currentTheme === "dark" ? "light" : "dark"} theme`, title: `Toggle to ${this.currentTheme === "dark" ? "light" : "dark"} theme` }, h("span", { class: this.currentTheme === "dark" ? "fa fa-sun-o" : "fa fa-moon-o" }))) : undefined, this.supportsAuthentication ? (h("coso-authentication-menu", { isAuthenticated: this.isAuthenticated, identityProviderEndpoint: this.identityProviderEndpoint, isMvc: this.isMvc, isIdentityProvider: this.isIdentityProvider, userName: this.userName, tenantName: this.tenantName, onAuthenticationMenuSignInClicked: () => this.menuSignInClicked.emit(), onAuthenticationMenuSignOutClicked: () => this.menuSignOutClicked.emit(), supportsAccountCreation: this.supportsAccountCreation, supportsTenantRename: this.supportsTenantRename, loginRedirectUrl: this.loginRedirectUrl, logoutRedirectUrl: this.logoutRedirectUrl }, h("slot", { name: "antiForgeryToken", slot: "antiForgeryToken" }), h("slot", { name: "dropdownMenuUserAuthenticated", slot: "dropdownMenuUserAuthenticated" }))) : undefined)),
        ];
        return (h("nav", { key: 'f7f5c6c8554accebfd36640f67db0b1dc6a70b2d', class: "navbar navbar-expand-lg navbar-dark bg-primary visible-nav" + (this.hasStickyNavbar ? " sticky-top " : "") }, this.supportsApplicationDrawer ? menuContent : this.wrapMenuWithContainerWhenApplicationDrawerIsNotSupported ? h("div", { class: "container" }, menuContent) : menuContent));
    }
    get el() { return getElement(this); }
};
CosoMenu.style = CosoMenuStyle0;

export { CosoMenu as coso_menu };

//# sourceMappingURL=coso-menu.entry.js.map